export const LOCAL_TOPICS = [
  { id:  1, emoji: '🍽️', ja: '今日食べたものを教えてください',            hint: '朝・昼・夜、どれでもOK！' },
  { id:  2, emoji: '🎬', ja: '最近見た映画やドラマは？',                   hint: 'おすすめポイントも教えて' },
  { id:  3, emoji: '✈️', ja: '行ってみたい国や場所は？',                   hint: 'その理由も書いてみよう' },
  { id:  4, emoji: '🎵', ja: '最近よく聴いている音楽は？',                 hint: 'アーティスト名や曲名を教えて' },
  { id:  5, emoji: '📚', ja: '最近読んだ本やマンガは？',                   hint: 'おすすめなら友達に紹介しよう' },
  { id:  6, emoji: '🌸', ja: '今の季節で好きなことは？',                   hint: '春夏秋冬、それぞれの楽しみ' },
  { id:  7, emoji: '🐾', ja: '飼っているペットや好きな動物は？',           hint: '写真の説明も日本語でどうぞ' },
  { id:  8, emoji: '🍕', ja: '好きな食べ物ベスト3を教えて！',             hint: '理由も添えるとなお良し' },
  { id:  9, emoji: '🎮', ja: '最近ハマっているゲームや趣味は？',           hint: '始めたきっかけも話してみよう' },
  { id: 10, emoji: '🌙', ja: '昨日の夜は何をしていましたか？',             hint: '日常の一コマを日本語で' },
  { id: 11, emoji: '☕', ja: '朝のルーティンを教えてください',             hint: '起きてから最初にすることは？' },
  { id: 12, emoji: '🏋️', ja: '運動や健康のために何かしていますか？',      hint: '小さな習慣でもOK' },
  { id: 13, emoji: '😂', ja: '最近笑ったエピソードは？',                   hint: '面白い話を日本語でシェア' },
  { id: 14, emoji: '🎂', ja: '誕生日に何かしたいことは？',                 hint: 'プレゼントや行きたい場所など' },
  { id: 15, emoji: '🌍', ja: '自分の国で有名な食べ物や文化は？',           hint: '日本との違いも面白い！' },
  { id: 16, emoji: '🖊️', ja: '日本語で一番難しいと思うことは？',          hint: '漢字？敬語？発音？' },
  { id: 17, emoji: '🏠', ja: '理想の家や部屋はどんな感じですか？',         hint: 'インテリアや立地など' },
  { id: 18, emoji: '👗', ja: '好きなファッションスタイルは？',             hint: 'ブランドや色の好みも' },
  { id: 19, emoji: '💼', ja: '将来やってみたい仕事は？',                   hint: '今の仕事・夢の仕事どちらでも' },
  { id: 20, emoji: '📸', ja: '写真を撮るのが好きですか？何を撮りますか？', hint: '風景・食べ物・人物…' },
  { id: 21, emoji: '🌏', ja: '日本語を学んでいる理由は何ですか？',         hint: 'きっかけや目標を教えて' },
  { id: 22, emoji: '🎁', ja: 'もらって嬉しかったプレゼントは？',           hint: 'エピソードも添えて' },
  { id: 23, emoji: '🚃', ja: '通勤・通学の方法を教えてください',           hint: '電車・バス・自転車・徒歩？' },
  { id: 24, emoji: '🌅', ja: '朝型ですか？夜型ですか？',                   hint: '理由も説明してみよう' },
  { id: 25, emoji: '🍜', ja: '自分で作れる料理を教えてください',           hint: '得意料理や好きなレシピ' },
  { id: 26, emoji: '🗣️', ja: '外国語を話すとき緊張しますか？',            hint: '克服したコツがあれば教えて' },
  { id: 27, emoji: '📱', ja: 'スマホでよく使うアプリは？',                 hint: 'SNS・ゲーム・勉強アプリなど' },
  { id: 28, emoji: '🏖️', ja: '海派？山派？どちらが好きですか？',          hint: 'どんな過ごし方が好き？' },
  { id: 29, emoji: '🎓', ja: '学生時代に一番好きだった科目は？',           hint: '理由も教えて' },
  { id: 30, emoji: '💭', ja: '最近考えていることや気になることは？',       hint: 'どんなトピックでも' },
  { id: 31, emoji: '🌿', ja: '環境のために何かしていますか？',             hint: 'エコバッグ・節電・リサイクルなど' },
  { id: 32, emoji: '🎤', ja: 'カラオケで必ず歌う曲は？',                   hint: '十八番を教えて！' },
  { id: 33, emoji: '🛋️', ja: '休日はどんな過ごし方をしますか？',          hint: 'インドア派？アウトドア派？' },
  { id: 34, emoji: '🔮', ja: '5年後の自分はどんな姿？',                    hint: '仕事・生活・言語レベルなど' },
  { id: 35, emoji: '💡', ja: '最近覚えた日本語の表現は？',                 hint: '使ってみた感想も教えて' },
  { id: 36, emoji: '🍁', ja: '子供の頃に好きだった遊びは？',               hint: '懐かしい思い出を語ろう' },
  { id: 37, emoji: '🌆', ja: '住んでいる街の好きなところは？',             hint: '食べ物・景色・人など' },
  { id: 38, emoji: '🛒', ja: '最近買って良かったものは？',                 hint: '生活が便利になったものでも' },
  { id: 39, emoji: '🎯', ja: '今年中に達成したい目標は？',                 hint: '日本語学習以外でもOK' },
  { id: 40, emoji: '👨‍👩‍👧', ja: '家族や大切な人への感謝を日本語で伝えてみよう', hint: '「ありがとう」以外の言葉で' },
  { id: 41, emoji: '🌙', ja: '好きなアニメやマンガのキャラクターは？',     hint: '理由も日本語で説明して' },
  { id: 42, emoji: '🧩', ja: 'ストレス解消法を教えてください',             hint: 'あなたの気分転換法は？' },
  { id: 43, emoji: '🚗', ja: '行ってみたい日本の場所は？',                 hint: '東京・京都・北海道…どこでも' },
  { id: 44, emoji: '🤝', ja: '日本のどんなところが好きですか？',           hint: '食・文化・アニメ・なんでも' },
  { id: 45, emoji: '🌈', ja: '好きな色とその理由は？',                     hint: '服・インテリア・景色など' },
  { id: 46, emoji: '🍺', ja: '好きな飲み物は何ですか？',                   hint: 'コーヒー派？お茶派？' },
  { id: 47, emoji: '🎨', ja: '芸術や創作活動に興味はありますか？',         hint: '絵・音楽・写真・料理など' },
  { id: 48, emoji: '⛅', ja: '好きな天気はどんな天気ですか？',             hint: '晴れ・雨・雪…その理由も' },
  { id: 49, emoji: '🔑', ja: '日本語学習で一番役に立った方法は？',         hint: 'アプリ・ドラマ・会話練習など' },
  { id: 50, emoji: '🌻', ja: '今一番楽しみにしていることは？',             hint: '近い将来のことでも夢でも' },
];

const TOPIC_KAOMOJI = {
  1:  '(っ˘ڡ˘ς)',
  2:  '(≧◡≦)',
  3:  '(～ω～)♡',
  4:  '(♪˘▿˘)♪',
  5:  '(´∀｀)ﾉ',
  6:  '(ﾟ▽ﾟ)/',
  7:  '(=ↀωↀ=)',
  8:  '(っ˘ω˘ς)',
  9:  '(≧∀≦)/',
  10: '( ˘ω˘ )zzz',
  11: '☕(´-ω-｀)',
  12: '(ง •̀_•́)ง',
  13: '(≧▽≦)/',
  14: '(ﾉ◕ヮ◕)ﾉ*',
  15: '(｡•̀ᴗ-)✧',
  16: '(´；ω；｀)',
  17: '(ﾉ◕ヮ◕)ﾉ',
  18: '(｀・ω・)ノ',
  19: '( •̀ω•́)✧',
  20: '(◕‿◕)✿',
  21: '(◍•ᴗ•◍)♡',
  22: '(ﾉ´ヮ`)ﾉ*',
  23: '🚃(｀･ω･)',
  24: '(˘▽˘>ԅ)',
  25: '(ﾉ◕ヮ◕)ﾉ',
  26: '(≧ω≦)',
  27: '(｀_´)ゞ',
  28: '🌊ヽ(°◇° )ノ',
  29: '(ゝ∀・)★',
  30: '(˘・_・˘)',
};

export function getLocalTodayTopic() {
  const jstOffset = 9 * 60 * 60 * 1000;
  const dayIndex = Math.floor((Date.now() + jstOffset) / 86400000);
  return LOCAL_TOPICS[dayIndex % LOCAL_TOPICS.length];
}

export const getKaomoji = (id) => TOPIC_KAOMOJI[id] || '(◕‿◕)ﾉ';
